"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');

var _types = require('web/screens/Signup/types');
var _amplitude = require('web/services/amplitude'); var _amplitude2 = _interopRequireDefault(_amplitude);

 const useStep = (
  // Refresh-resume seed from the signup draft (see resumeStepsFromDraft):
  // where to land and how far forward the nav stays clickable.
  initial,
) => {
  const [currentStep, setCurrentStep] = _react.useState.call(void 0, _nullishCoalesce(_optionalChain([initial, 'optionalAccess', _ => _.step]), () => ( _types.SetupSteps.PERSONAL_INFO)))
  // High-water mark: the furthest step the user has reached. Back-navigation
  // never lowers it, so already-visited steps stay reachable forward from the
  // step nav; editing an earlier answer clamps it (see clampMaxStep) because
  // downstream steps re-derive parked state on their submit handlers.
  const [maxStep, setMaxStep] = _react.useState.call(void 0, _nullishCoalesce(_nullishCoalesce(_optionalChain([initial, 'optionalAccess', _2 => _2.maxStep]), () => ( _optionalChain([initial, 'optionalAccess', _3 => _3.step]))), () => ( _types.SetupSteps.PERSONAL_INFO)))

  const gotoStep = _react.useCallback.call(void 0, (s) => {
    setCurrentStep(s)
    setMaxStep(m => Math.max(m, s))
  }, [])

  const goBack = _react.useCallback.call(void 0, 
    () => setCurrentStep(s => Math.max(s - 1, _types.SetupSteps.PERSONAL_INFO)),
    [],
  )

  const clampMaxStep = _react.useCallback.call(void 0, 
    (s) => setMaxStep(m => Math.min(m, s)),
    [],
  )

  _react.useEffect.call(void 0, 
    () => {
      _amplitude2.default.logEvent(`Signup step: ${_types.SetupSteps[currentStep]}`)
    },
    [currentStep],
  )

  return {
    currentStep,
    maxStep,
    goBack,
    gotoStep,
    clampMaxStep,
  }
}; exports.useStep = useStep
